module.exports = __webpack_public_path__ + "adbbddbaf98c1ce93c3e758c66f18e6a.png";